import { randomElement, randomInt } from "../random";

type GoldValue = number | (() => number);

export const MOB_GOLD_VALUES: Record<string, GoldValue> = {
	// Weak mobs

	Squid: 5,
	AlbinoSquid: 5,
	Horned: 5,

	// Standard mobs
	Slugant: 10,
	ToxicSlug: 20,
	Robot: 10,
	Biter: 15,
	FloatingRobot: 10,

	// Tougher mobs
	PlowRobot: 50,
	BossPlowRobot: 350,
	BlackHoleRobot: 1000,

	// Big mobs
	BigSquid: 50,
	MiningRobot: 120,
	ArtilleryRobot: 150,

	// Portals / spawners (awarded when placed at level start)
	Portal2: 50,
	ReinforcedPortal2: 100,
	RobotSpawner: 80,

	// Testing/dev
	ArrowMob: 10,
	Amoeba: 10,
	HeavyRobot: 50,
	JetpackMob: 30,
};

export function getMobGoldValue(key: string): number {
	const entry = MOB_GOLD_VALUES[key];
	if (entry === undefined) return 0;
	return typeof entry === "function" ? entry() : entry;
}
